import api, { handleError } from "../index";
import { getSessionGuid } from "src/lib/tracking-cookies";

export function orderGiftService({ payload, apiToken, offer }) {
  const headers = {};

  if (apiToken != null) {
    headers.Authorization = `Bearer ${apiToken}`;
  }

  const {
    email,
    first_name,
    surname,
    delivery_address1,
    delivery_address2,
    delivery_city,
    delivery_country,
    delivery_postcode,
    encryptedCardNumber,
    encryptedExpiryMonth,
    encryptedExpiryYear,
    encryptedSecurityCode,
    products,
    ...rest
  } = payload;

  const orderData = {
    session_guid: getSessionGuid(),
    email: email ? email.trim() : "",
    first_name: first_name ? first_name.trim() : "",
    surname: surname ? surname.trim() : "",
    delivery_address1: delivery_address1 ? delivery_address1.trim() : "",
    delivery_address2: delivery_address2 ? delivery_address2.trim() : "",
    delivery_city: delivery_city ? delivery_city.trim() : "",
    delivery_country: delivery_country ? delivery_country.trim() : "",
    delivery_postcode: delivery_postcode ? delivery_postcode.trim() : "",
    encryptedCardNumber: encryptedCardNumber,
    encryptedExpiryMonth: encryptedExpiryMonth,
    encryptedExpiryYear: encryptedExpiryYear,
    encryptedSecurityCode: encryptedSecurityCode,
    products,
    ...rest,
  };

  return api({
    method: "post",
    url: `/orders/gift${offer ? `?offer=${offer}` : ""}`,
    headers: { ...api.defaults.headers, ...headers },
    data: orderData,
  })
    .then((response) => ({ error: null, data: response.data }))
    .catch((error) => {
      const errorPayload = handleError(error);
      return {
        ...errorPayload,
        data: null,
      };
    });
}
